<div class="fs-2" mat-dialog-title>
    Activation de votre compte
</div>
<div mat-dialog-content>
    <img src="../../../../../assets/Logo-Polygone-Formations.webp" /><br/>
    Bienvenue sur Lybox,<br/>
    <br/>
    Nous allons vous aider pendant toute votre formation à dénicher les meilleurs offres.<br/>
    <br/>
    Un abonnement de 1 mois à Lybox vous est offert dans votre programme de formation, il ne vous reste plus qu'a l'activer
    pour en profiter.
    <br/>
</div>
<div mat-dialog-actions class="center">
    <button type="button" (click)="onYesClick()" class="btn btn-primary w-100">
        <i class="fa fa-check" aria-hidden="true"></i> Activer mon abonnement
    </button>
</div>
